export default [
  {
    title: 'Ziektekosten',
    icon: 'HomeIcon',
    route: 'app-pzs',
    action: 'read',
    resource: 'pzs',
  },
  {
    title: 'Motorrijtuigen',
    icon: 'TruckIcon',
    route: 'app-wam',
    action: 'read',
    resource: 'wam',
  },
  {
    title: 'Reis',
    icon: 'NavigationIcon',
    route: 'app-ro',
    action: 'read',
    resource: 'ro',
  },
]
